/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserSettings } from "../models/UserSettings";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class UserSettingsService {
  /**
   * @param azureIdentityId
   * @returns UserSettings
   * @throws ApiError
   */
  public static userSettingsGet(
    azureIdentityId?: string | null
  ): CancelablePromise<UserSettings> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/UserSettings/Get",
      query: {
        azureIdentityId: azureIdentityId,
      },
    });
  }

  /**
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static userSettingsUpdate(
    requestBody: UserSettings
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/UserSettings/Update",
      body: requestBody,
      mediaType: "application/json",
    });
  }
}
